import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPurchaseCreditNote } from "api/purchaseCreditNote.api";
import {
  invalidatePurchaseCreditNoteSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

export const useCreatePurchaseCreditNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPurchaseCreditNote,
    onSuccess: () => {
      invalidatePurchaseCreditNoteSide(queryClient);
      invalidateVendorSide(queryClient);
    },
  });
};
